import GestionStocksController from './gestion.stocks.controller';

export default {
    template: require('./gestion.stocks.html'),
    controller: GestionStocksController
};
